import { useLottie } from "lottie-react";
import React from 'react';
import { bell } from '../../../assets';
import { Cancel } from 'iconoir-react';

const PushNotification = ({ title, message, onClose }) => {
  const options = {
    animationData: bell,
    loop: true,
    style: { height: 40, width: 40 }
  };

  const { View } = useLottie(options);

  return (
    <>
      <iframe src={bell} allow="autoplay" title="notification_audio" id="audio" style={{ display: 'none' }} />
      <audio id="player" autoPlay loop>
        <source src={bell} />
      </audio>

      <div className="fixed top-4 right-4 z-50 animate-slide-in-right">
        <div className="w-96 bg-white rounded-2xl shadow-soft-xl border border-surface-100 overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between px-4 py-3 bg-gradient-to-r from-primary-500 to-primary-600">
            <span className="text-sm font-semibold text-white">New Notification</span>
            {onClose && (
              <button
                onClick={onClose}
                className="p-1 rounded-lg text-white/80 hover:text-white hover:bg-white/10 transition-colors"
              >
                <Cancel strokeWidth={2} className="w-4 h-4" />
              </button>
            )}
          </div>

          {/* Content */}
          <div className="p-4">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center">
                {View}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-surface-800 truncate">{title}</p>
                <p className="text-sm text-surface-500 mt-0.5 line-clamp-2">{message}</p>
                <p className="text-xs text-primary-500 font-medium mt-2">Just now</p>
              </div>
            </div>
          </div>

          {/* Progress bar */}
          <div className="h-1 bg-surface-100">
            <div className="h-full bg-primary-500 notification-progress" />
          </div>
        </div>
      </div>
    </>
  )
}

export default PushNotification
